export const makePasswordMatchValidator =
  (referencePassword: string) =>
  (v: unknown): string | undefined => {
    if (!referencePassword || !v) {
      return undefined;
    }
    return v !== referencePassword ? 'Passwords do not match' : undefined;
  };
